import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { OverrideStatusEnum } from '../../../constants/override-status.enum';
import { Router } from '@angular/router';
import { IUserProfileDataModel } from '../../../entities-api/IUserProfileDataModel';
import { IDictionaryItemModel } from '../../../entities-api/IDictionaryItemModel';
import { IGlobalEmployeeDictionariesModel } from '../../../entities-api/IGlobalEmployeeDictionariesModel';
import { forkJoin, from } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import * as ExcelJS from 'exceljs';
import { IBulkProfileResultModel } from '../../../entities-api/IBulkProfileResultModel';
import * as _ from 'lodash';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'opm-createuser-profile',
  templateUrl: './opm-createuser-profile.component.html',
  styleUrls: ['./opm-createuser-profile.component.less'],
  standalone: false
})
export class OpmCreateuserProfileComponent implements OnInit {

  constructor(
    protected http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private toasterService: ToastrService
  ) { }

  profile: IUserProfileDataModel = <IUserProfileDataModel>{ Origin: {}, Override: {}, Errors: [] };
  dictionaries: IGlobalEmployeeDictionariesModel = <IGlobalEmployeeDictionariesModel>{};
  visiblMessagePopup: boolean = false;
  dataLoaded: boolean = false;
  overrideStatusEnum = OverrideStatusEnum;
  selectedStatus = <IDictionaryItemModel>{};
  selectedOffice = <IDictionaryItemModel>{};
  selectedCountry = <IDictionaryItemModel>{};
  selectedOrganization = <IDictionaryItemModel>{};
  errorMessage: string;
  visiblErrorPopup: boolean = false;
  userId: string;
  emailPattern: string = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";
  strnumspacePattern: string = "^[a-zA-Z0-9 ]*$";
  strnumsPattern: string = "^[a-zA-Z0-9]*$";
  strAllPattern: string = "^[a-zA-Z0-9]+[^]*$";
  selectedFiles: FileList;
  currentFile: File;
  arrayBuffer: any;
  filelist: any;
  isshow: boolean = false;
  bulkProfileResults: IBulkProfileResultModel[];
  action: string;
  type: number = 1;
  options: boolean = true;
  isAudit: boolean = false;
  isUploading: boolean = false;
  private fileParsePromise: Promise<any[]> = null;

  @ViewChild('emailAddress') emailInput: ElementRef
  @ViewChild('firstName') firstNameInput: ElementRef
  @ViewChild('lastName') lastNameInput: ElementRef
  @ViewChild('outlookName') outlookNameInput: ElementRef
  @ViewChild('employeeAlias') employeeAliasInput: ElementRef
  @ViewChild('fileInput') fileInput: ElementRef

  ngOnInit() {
    window.scrollTo(0, 0);

    this.activatedRoute.params.subscribe((params: Params) => {
      this.userId = params['userId'];

      var dictionariesPromise = this.userService.getDictionaries();
      var getUserProfilePromise = this.userService.getUserProfile(this.userId);

      forkJoin([from(dictionariesPromise), from(getUserProfilePromise)])
        .toPromise().then((data: any) => {
          this.dictionaries = data[0];
          this.profile = data[1];

          this.profile.Override.Comment = null;
          this.profile.Override.TicketNumber = null;

          this.setDefaultValues();
          this.dataLoaded = true;
        }).catch(err => {
          this.router.navigate(["/"]);
          return;
        });
    });
  }

  save() {

    this.profile.Override.PreferredFullName = `${this.profile.Override.LastName}, ${this.profile.Override.FirstName}`;

    this.profile.Override.FirstName = this.firstNameInput.nativeElement.value;
    this.profile.Override.LastName = this.lastNameInput.nativeElement.value;
    this.profile.Override.Email = this.emailInput.nativeElement.value;

    this.userService.createUserProfile(<any>this.profile.Override).then((result) => {
      if (result == true) {
        this.toasterService.success('User added successfully');
        this.action = Constants.ProfileLogConst.SingleProfile;
        this.userService.addProfileLogs(this.action);
      } else {
        this.toasterService.error('User already exists in OPM');
      }
    }, this.handleError);
  }

  private handleError = (response) => {
    this.visiblMessagePopup = false;
    this.visiblErrorPopup = true;
    this.errorMessage = response.error.Message;
  }

  private refreshUsersAndRedirect() {
    this.userService.getUsers().then(() => {
      this.router.navigateByUrl("");
    });
  }

  fillDescription(destinationFildName: string, sourceFieldName: string, items: IDictionaryItemModel[]) {
    var filteredItems: IDictionaryItemModel[] = items.filter(item => {
      return item.Code === this.profile.Override[sourceFieldName];
    });

    if (filteredItems.length > 0) {
      this.profile.Override[destinationFildName] = filteredItems[0].Description;
    } else {
      this.profile.Override[destinationFildName] = null;
      this.profile.Override[sourceFieldName] = null;
    }
  }

  changeStatus(): void {
    this.profile.Override.EmployeeStatusDesc = this.selectedStatus.Description;
    this.profile.Override.EmployeeStatusCode = this.selectedStatus.Code;
  }

  changeCountry(): void {
    this.profile.Override.CountryDesc = this.selectedCountry.Description;
    this.profile.Override.CountryCode = this.selectedCountry.Code;
  }

  changeOffice(): void {
    this.profile.Override.OfficeDesc = this.selectedOffice.Description;
    this.profile.Override.OfficeCode = this.selectedOffice.Code;
  }

  changeOrganization(): void {
    this.profile.Override.OrganizationDesc = this.selectedOrganization.Description;
    this.profile.Override.OrganizationCode = this.selectedOrganization.Code;
  }

  parseBoolean(value: any): boolean {
    return value === true || value === 'true';
  }

  setDefaultValues(): void {
    this.selectedStatus = this.dictionaries.Statuses.filter((status) => {
      return status.Code === this.profile.Override.EmployeeStatusCode
        && status.Description === this.profile.Override.EmployeeStatusDesc;
    })[0];

    this.selectedCountry = this.dictionaries.Countries.filter((country) => {
      return country.Code === this.profile.Override.CountryCode
        && country.Description === this.profile.Override.CountryDesc;
    })[0];

    this.selectedOffice = this.dictionaries.Offices.filter((office) => {
      return office.Code === this.profile.Override.OfficeCode
        && office.Description === this.profile.Override.OfficeDesc;
    })[0];

    this.selectedOrganization = this.dictionaries.Organizations.filter((organization) => {
      return organization.Code === this.profile.Override.OrganizationCode
        && organization.Description === this.profile.Override.OrganizationDesc;
    })[0];

    this.profile.Override.MemberFirmCode = this.profile.Override.MemberFirmCode.toLocaleUpperCase();
    this.dictionaries.MemberFirms = this.dictionaries.MemberFirms.map((memberFirm) => memberFirm.toLocaleUpperCase());
  }

  // Get raw cell value from ExcelJS cell
  private getCellValue(cell: ExcelJS.Cell): any {
    const value = cell.value;
    
    if (value === null || value === undefined) {
      return '';
    }

    // Handle different cell types
    if (typeof value === 'object') {
      // Rich text
      if ('richText' in value && Array.isArray((value as any).richText)) {
        return (value as any).richText.map((rt: any) => rt.text || '').join('');
      }
      // Formula - get the calculated result
      if ('formula' in value) {
        const result = (value as any).result;
        if (result === null || result === undefined) return '';
        return result;
      }
      // Hyperlink
      if ('text' in value) {
        return (value as any).text || '';
      }
      // Error
      if ('error' in value) {
        return '';
      }
      // Date
      if (value instanceof Date) {
        return value;
      }
      return '';
    }

    return value;
  }

  // Convert value to string for the model
  private valueToString(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value instanceof Date) {
      return value.toISOString();
    }
    return String(value).trim();
  }

  // Convert Excel to JSON array matching the backend model
  private async excelToJson(buffer: ArrayBuffer): Promise<any[]> {
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    const worksheet = workbook.worksheets[0];
    if (!worksheet || worksheet.rowCount < 2) {
      return [];
    }

    // Get headers from first row
    const headers: string[] = [];
    const headerRow = worksheet.getRow(1);
    const colCount = headerRow.cellCount;
    
    for (let col = 1; col <= colCount; col++) {
      const cell = headerRow.getCell(col);
      const headerValue = this.valueToString(this.getCellValue(cell));
      headers[col] = headerValue;
    }

    const result: any[] = [];

    // Process data rows (starting from row 2)
    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      if (rowNumber === 1) return; // Skip header row

      const rowData: any = { RowNumber: rowNumber };
      let hasData = false;

      for (let col = 1; col <= colCount; col++) {
        const header = headers[col];
        if (!header) continue;

        const cell = row.getCell(col);
        let cellValue = this.valueToString(this.getCellValue(cell));

        // Normalize PPMD values (Yes/No) - backend expects exactly "Yes" or "No"
        if (header === 'PPMD' && cellValue) {
          const lowerVal = cellValue.toLowerCase();
          if (lowerVal === 'yes' || lowerVal === 'y' || lowerVal === 'true' || lowerVal === '1') {
            cellValue = 'Yes';
          } else if (lowerVal === 'no' || lowerVal === 'n' || lowerVal === 'false' || lowerVal === '0') {
            cellValue = 'No';
          }
        }

        rowData[header] = cellValue;
        if (cellValue !== '') {
          hasData = true;
        }
      }

      // Only add rows that have at least one non-empty cell
      if (hasData) {
        result.push(rowData);
      }
    });

    return result;
  }

  // Read file and parse Excel - returns a Promise
  private readAndParseFile(file: File): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = async () => {
        try {
          const data = fileReader.result as ArrayBuffer;
          const result = await this.excelToJson(data);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      };
      fileReader.onerror = () => {
        reject(new Error('Error reading file'));
      };
    });
  }

  // File selection handler
  selectFile(event): void {
    this.selectedFiles = event.target.files;
    this.currentFile = this.selectedFiles?.item(0);
    this.bulkProfileResults = undefined;
    this.isshow = false;
    this.filelist = undefined;
    this.fileParsePromise = null;

    if (!this.currentFile) {
      return;
    }

    // Store the promise so upload() can await it if needed
    this.fileParsePromise = this.readAndParseFile(this.currentFile);
    this.fileParsePromise.then(data => {
      this.filelist = data;
    }).catch(error => {
      this.toasterService.error('Error parsing Excel file!');
      this.filelist = undefined;
    });
  }

  // Helper method to show/hide the global spinner
  private updateSpinnerState(show: boolean): void {
    const spinner = document.getElementById("spinner-container");
    if (spinner) {
      spinner.style.display = show ? 'block' : 'none';
    }
  }

  upload(): void {
    if (this.currentFile == null) {
      this.toasterService.error('Please Select file!');
      return;
    }
    if (!this.validateFile(this.currentFile.name)) {
      this.toasterService.error('Selected file format is not Supported!');
      return;
    }

    // Show spinner immediately when upload button is clicked
    this.isUploading = true;
    this.updateSpinnerState(true);

    // Wait for parsing if still in progress, then upload
    const parsePromise = this.fileParsePromise || this.readAndParseFile(this.currentFile);
    parsePromise.then(data => {
      this.filelist = data;
      this.performUpload();
    }).catch(error => {
      this.toasterService.error('Error parsing Excel file!');
      this.isUploading = false;
      this.updateSpinnerState(false);
    });
  }

  private performUpload(): void {
    if (!this.filelist || this.filelist.length === 0) {
      this.toasterService.error('No data found in the file!');
      this.isUploading = false;
      this.updateSpinnerState(false);
      return;
    }

    var promise;
    promise= this.userService.upload(this.filelist);

    promise.then(data => {
      this.bulkProfileResults = data
      if (data.length != 0) {
        this.isshow = true;
        this.toasterService.warning('File uploaded with logs');
      } else {
        this.isshow = false;
        this.toasterService.success('File uploaded successfully');
      }
      this.clearFileInput();
      this.isUploading = false;
      // Note: The HTTP interceptor will hide the spinner when the request completes

    }, error => {
      this.toasterService.error('File upload failed!');
      this.currentFile = undefined;
      this.clearFileInput();
      this.isUploading = false;
      // Note: The HTTP interceptor will hide the spinner when the request fails
    });
    
    this.selectedFiles = undefined;
  }

  // Helper method to clear the file input
  private clearFileInput(): void {
    const fileInputElement = document.querySelector("input[type='file']") as HTMLInputElement;
    if (fileInputElement) {
      fileInputElement.value = '';
    }
  }

  validateFile(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'xlsx') {
      return true;
    }
    else {
      return false;
    }
  }

  DownloadTemplate(): void {
    this.userService.GetExcelFile().subscribe(data => {
      if (data != null) {
        var FileType = 'XLSX'
        const linkSource = 'data:application/' + FileType + ';base64,' + data;
        const downloadLink = document.createElement("a");
        const fileName = 'Template' + '.' + FileType;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }
}
